
// This file is shared across the demos.

import React from 'react';
import {  Link } from 'react-router-dom'

import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import VideosIcon from '@material-ui/icons/VideoLibrary';
import ImagesIcon from '@material-ui/icons/Collections';

import DatasetsIcon from '@material-ui/icons/Folder';
import SettingsIcon from '@material-ui/icons/Settings';
import ClassifiersIcon from '@material-ui/icons/GroupWork';
import EntitiesIcon from '@material-ui/icons/People';

import NewJobIcon from '@material-ui/icons/LibraryAdd';
import MailIcon from '@material-ui/icons/Mail';
import DeleteIcon from '@material-ui/icons/Delete';
import ReportIcon from '@material-ui/icons/Report';

import Tooltip from '@material-ui/core/Tooltip';

export const mailFolderListItems = (
    <div>
        <ListItem component={Link} to="/videos" button>
            <ListItemIcon>
                <VideosIcon />
            </ListItemIcon>
            <ListItemText primary="Videos" />
        </ListItem>
        <ListItem component={Link} to="/images" button>
            <ListItemIcon>
                <ImagesIcon />
            </ListItemIcon>
            <ListItemText primary="Images" />
        </ListItem>
        <ListItem component={Link} to="/entities" button>
            <ListItemIcon>
                <EntitiesIcon />
            </ListItemIcon>
            <ListItemText primary="Entities" />
        </ListItem>
        <ListItem component={Link} to="/datasets" button>
            <ListItemIcon>
                <DatasetsIcon />
            </ListItemIcon>
            <ListItemText primary="Datasets" />
        </ListItem>
        <ListItem component={Link} to="/labeler/1/1" button>
            <ListItemIcon>
                <DatasetsIcon />
            </ListItemIcon>
            <ListItemText primary="Labeler" />
        </ListItem>
        <ListItem component={Link} to="/classifiers" button>
            <ListItemIcon>
                <ClassifiersIcon />
            </ListItemIcon>
            <ListItemText primary="Classifiers" />
        </ListItem>
    </div>
);

export const otherMailFolderListItems = (
  <div>
    {/*
    <ListItem component={Link} to="/jobs/new" button>
        <ListItemIcon>
            <NewJobIcon />
        </ListItemIcon>
        <ListItemText primary="New Job" />
    </ListItem>*/}
  </div>
);



// WEBPACK FOOTER //
// ./src/components/tileData.js